module.exports = __webpack_public_path__ + "img/button_icon_linckard.537659e.svg";